import { getRandomEntries } from '@/utils/array';

const nouns = [
  'apple',
  'ball',
  'cat',
  'dog',
  'house',
  'car',
  'tree',
  'book',
  'phone',
  'table',
  'chair',
  'computer',
  'pen',
  'pencil',
  'shoe',
  'hat',
  'shirt',
  'bag',
  'clock',
  'window',
  'door',
  'bed',
  'sofa',
  'lamp',
  'bottle',
  'glass',
  'cup',
  'plate',
  'fork',
  'knife',
  'spoon',
  'box',
  'bag',
  'road',
  'street',
  'bridge',
  'river',
  'mountain',
  'ocean',
  'beach',
  'island',
  'city',
  'village',
  'town',
  'country',
  'world',
  'sun',
  'moon',
  'star',
  'cloud',
  'rain',
  'snow',
  'wind',
  'fire',
  'water',
  'air',
  'earth',
  'garden',
  'park',
  'school',
  'university',
  'teacher',
  'student',
  'doctor',
  'nurse',
  'police',
  'firefighter',
  'engineer',
  'artist',
  'musician',
  'singer',
  'actor',
  'writer',
  'friend',
  'family',
  'child',
  'parent',
  'brother',
  'sister',
  'baby',
  'boy',
  'girl',
  'man',
  'woman',
  'person',
  'people',
  'animal',
  'bird',
  'fish',
  'insect',
  'tree',
  'flower',
  'leaf',
  'grass',
  'rock',
  'sand',
  'stone',
  'food',
  'drink',
  'game',
];

const verbs = [
  'run',
  'jump',
  'swim',
  'eat',
  'drink',
  'sleep',
  'read',
  'write',
  'talk',
  'walk',
  'sit',
  'stand',
  'play',
  'sing',
  'dance',
  'laugh',
  'cry',
  'cook',
  'watch',
  'listen',
  'drive',
  'fly',
  'buy',
  'sell',
  'learn',
  'teach',
  'help',
  'build',
  'break',
  'open',
  'close',
  'cut',
  'give',
  'take',
  'throw',
  'catch',
  'find',
  'lose',
  'push',
  'pull',
  'climb',
  'fall',
  'run',
  'jump',
  'hope',
  'plan',
  'wait',
  'hope',
  'wish',
  'imagine',
  'believe',
  'trust',
  'feel',
  'love',
  'hate',
  'need',
  'want',
  'ask',
  'answer',
  'shout',
  'whisper',
  'scream',
  'bake',
  'boil',
  'fry',
  'grill',
  'stir',
  'mix',
  'pour',
  'clean',
  'wash',
  'dry',
  'repair',
  'mend',
  'fix',
  'sew',
  'knit',
  'weave',
  'fold',
  'iron',
  'paint',
  'draw',
  'color',
  'study',
  'practice',
  'train',
  'exercise',
  'lift',
  'carry',
  'move',
  'shake',
  'stretch',
  'yawn',
  'smile',
  'frown',
  'hug',
  'kiss',
  'comb',
  'brush',
  'wave',
];

export const getRandomWords = (
  count = 3,
  type: 'nouns' | 'verbs' | 'any' = 'any',
  exceptions: Array<string> = [],
) => {
  switch (type) {
    case 'nouns':
      return getRandomEntries(nouns, count, exceptions);
    case 'verbs':
      return getRandomEntries(verbs, count, exceptions);
    default:
      return getRandomEntries([...nouns, ...verbs], count, exceptions);
  }
};
